import { cva } from "class-variance-authority";

export { default as Sheet } from "./Sheet.vue";
export { default as SlideInLayer } from "./SlideInLayer.vue";
export { default as SlideInLayerClose } from "./SlideInLayerClose.vue";

export const contentVariants = cva(
    "flex flex-col [&>div]:pt-4 [&>div:first-of-type]:pt-5 [&>div]:px-5 [&>div:last-of-type]:pb-4 [&>div]:border-secondary",
    {
        variants: {
            variant: {
                default: "",
                filters:
                    "[&>div]:pt-0 [&>div:first-of-type]:pt-4 [&_#footer]:pt-4 [&>div]:px-6 [&>div:nth-of-type(2)]:py-0 [&>div:first-of-type]:pb-1 [&>div:first-of-type]:bg-utility-gray-50 [&>div:first-of-type]:border-b",
                details:
                    "sm:max-w-[500px] [&>div]:pt-6 [&>div]:px-6 [&>div:nth-of-type(2)]:order-first [&>div:nth-of-type(2)]:py-0 [&>div:nth-of-type(2)]:pl-5 [&>div:nth-of-type(2)]:pr-12 [&_#footer]:p-0 [&_#footer]:relative [&>div:last-of-type]:border-t",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
);

export const titleVariants = cva(
    "text-xl/normal font-semibold text-primary transition-font ease-in duration-200 break-all",
    {
        variants: {
            variant: {
                default: "",
                filters_from: "text-lg/normal font-semibold text-primary",
                filters_to:
                    "text-lg/normal scale-[0.8] -translate-x-[10%] font-normal text-tertiary",
                details: "text-2xl font-semibold text-primary",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
);

export const descriptionVariants = cva(
    "text-base font-medium text-tertiary transition-font ease-out duration-300",
    {
        variants: {
            variant: {
                default: "",
                filters_from:
                    "text-lg/normal scale-[0.8] -translate-y-1 -translate-x-[10%] font-normal text-tertiary whitespace-nowrap",
                filters_to:
                    "text-lg/normal -translate-y-1 font-semibold text-primary",
                details: "text-base text-utility-gray-700",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
);
